import { ReactElement, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  index: number;
  value: number;
}

export function TabPanel({ children, value, index, ...other }: Props): ReactElement {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}
